import Fitting from '@/models/Fitting';

export default class UpdateOrders
{
    /**
     * Vue Object
     */
    v = null;

    /**
     * @type {?Record<string, any>}
     */
    options = null;

    constructor(v, options = null)
    {
        this.v = v;

        if(typeof options !== 'object')
        {
            throw new TypeError(`options must be an object, got ${typeof options}`);
        }
        this.options = options;
    }

    async handle()
    {
        const orders = [];
        /** @type {?Fitting} */
        const rightFitting = this.v.$store.getters['lensOrder/getFitting']('right');
        /** @type {?Fitting} */
        const leftFitting  = this.v.$store.getters['lensOrder/getFitting']('left');

        this.v.$store.commit('overlay/setText', this.v.$t('overlay.updating_orders'));

        if(rightFitting)
        {
            orders.push(rightFitting.toOrder());
        }

        if(leftFitting)
        {
            orders.push(leftFitting.toOrder());
        }

        const data = { orders };
        if(this.options !== null)
        {
            data.options = this.options;
        }

        const response = await this.v.$store.dispatch('orders/update', data);
        console.log('These orders have been updated:', orders);
        return response;
    }
}
